import React from 'react';
import isEmpty from 'lodash/isEmpty';

import LoadingContent from '../LoadinContent';
import UploadProjectModalForm from '../UploadProjectModalForm';
import { WizardForUploadAndDeployProps, WizardReturnType } from '../types';
import SelectClusters from './SelectClusters';
import errorSetup from '../errorModalSetup';

const Wizard = ({
  selectRef,
  continueToSelectClusters,
  handleUploadAndDeploy,
  handleBackClick,
  pristine,
  invalid,
  onClose,
  environmentsList,
  isLoadingClusters,
  isUploadingAndDeploying,
  uploadAndDeployError,
  clusters,
  authenticate,
  change,
}: WizardForUploadAndDeployProps): WizardReturnType => {
  let setup: WizardReturnType = {
    title: 'Upload Project & Deploy',
    primaryAction: {
      disabled: pristine || invalid,
      text: 'Continue',
      'data-test': 'continue-upload-and-deploy-project-button',
      onClick: continueToSelectClusters,
      loading: authenticate || isLoadingClusters,
      style: { borderRadius: '4px' },
    },
    content: (
      <UploadProjectModalForm
        change={change}
        environmentsList={environmentsList}
      />
    ),
    glyph: 'deployment-export',
  };

  if (uploadAndDeployError) {
    setup = errorSetup(onClose);
  } else if (isUploadingAndDeploying) {
    setup = {
      ...setup,
      primaryAction: undefined,
      secondaryActions: undefined,
      content: <LoadingContent />,
    };
  } else if (!isEmpty(clusters)) {
    setup = {
      ...setup,
      primaryAction: {
        ...setup.primaryAction,
        text: 'Upload & Deploy',
        'data-test': 'upload-and-deploy-project-button',
        onClick: handleUploadAndDeploy,
        loading: false,
      },
      content: <SelectClusters ref={selectRef} clusters={clusters} />,
      onBackClick: handleBackClick,
    };
  }

  if (!uploadAndDeployError && !isUploadingAndDeploying) {
    setup.secondaryActions = [
      {
        text: 'Cancel',
        onClick: onClose,
        'data-test': 'cancel-button',
        style: { borderRadius: '4px' },
      },
    ];
  }

  return setup;
};

export default Wizard;
